import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './Home';
import BookingPage from './Booking';
import MyBookingsPage from './MyBookings';
import LabManagementPage from './LabManagement';
import BookingManagementPage from './BookingManagement';
import { useKeycloak } from './KeycloakContext';
import LoadingPage from './Loading';

const PrivateRoute = ({ children, role }) => {
  const { keycloak, keycloakInitialized, hasRole } = useKeycloak();

  if (!keycloakInitialized) {
    return <LoadingPage />;
  }

  if (!keycloak.authenticated || !hasRole(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const UnauthorizedPage = () => {
  const { keycloak } = useKeycloak();
  
  const handleLogout = () => {
    if (keycloak) {
      document.cookie = "oauth2_proxy=; Path=/; Domain=.silabor.it; Expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; HttpOnly";
      document.cookie = "_oauth2_proxy=; Path=/; Domain=.silabor.it; Expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; HttpOnly";
      keycloak.logout({ redirectUri:'https://silabor.it' });
    }
  };
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <h1 className="text-4xl font-bold mb-6">401 Unauthorized</h1>
      <p className="mb-8">Non hai i permessi necessari per accedere a questa piattaforma.</p>
      <button 
        onClick={handleLogout}
        className="px-4 py-2 bg-white text-black border-2 border-black uppercase text-sm font-semibold shadow hover:bg-black hover:text-white"
      >
        Logout
      </button>
    </div>
  );
};

const RedirectBasedOnRole = () => {
  const { hasRole } = useKeycloak();

  if (hasRole("UNIVERSITY")) {
    return <Navigate to="/lab-management" replace />;
  }

  if (hasRole("SCHOOL")) {
    return <Navigate to="/home" replace />;
  }

  return <UnauthorizedPage />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RedirectBasedOnRole />} />
        <Route path="/home" element={
          <PrivateRoute role="SCHOOL">
            <HomePage />
          </PrivateRoute>
        } />
        <Route path="/booking/:id" element={
          <PrivateRoute role="SCHOOL">
            <BookingPage />
          </PrivateRoute>
        } />
        <Route path="/my-bookings" element={
          <PrivateRoute role="SCHOOL">
            <MyBookingsPage />
          </PrivateRoute>
        } />
        <Route path="/lab-management" element={
          <PrivateRoute role="UNIVERSITY">
            <LabManagementPage />
          </PrivateRoute>
        } />
        <Route path="/booking-management" element={ // Add the new route
          <PrivateRoute role="UNIVERSITY">
            <BookingManagementPage />
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
};

export default App;
